import React, { Component } from "react";
import ReactDOM from "react-dom";
import ReactGA from 'react-ga';
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import * as serviceWorker from "./serviceWorker";

import "./index.css";
import "normalize.css";
import "css/Arrival.css";
import "css/Introduction.css";
import "css/Login.css";
import "css/Popup.css";
import "css/Problem.css";
import "css/Conclusion.css";
import Error404 from "./Error404";
import Login from "login/Login";
import Introduction from "introduction/Introduction";
import Arrival from "arrival/Arrival";
import Problem from "problem/Problem";
import Problem2 from "problem/Problem2";
import Problem3 from "problem/Problem3";
import Solution from "solution/Solution";
import Solution2 from "solution/Solution2";
import Solution3 from "solution/Solution3";
import Conclusion from "conclusion/Conclusion";

import { API_URL } from "./config";

// Does the user's browser support the HTML5 history API?
// If the user's browser doesn't support the HTML5 history API then we
// will force full page refreshes on each page change.
const supportsHistory = "pushState" in window.history;

// const mockData = {
//   SKU_Count: 65,
//   Facings: 23764,
//   Avg_Weekly_Sales: 2778,
//   "Annual Sales": 2778,
//   Transaction_Count: 457,
//   On_Hand_Adjustment_Dollars: 752,
//   On_Hand_Adjustment_Units: 5500,
//   LTSA_Score: 4.5,
//   BOPIS_Cancel_Retail: 1200,
//   Extend_Cancel_Retail: 4562
// };

const initialState = {
  storeNumber: "",
  email: "",
  isStoreNumberValid: true,
  loading: false
};

class App extends Component {
  constructor(props) {
    super(props);

    const data =
      window.sessionStorage.pickTicketData || JSON.stringify(initialState);

    this.state = JSON.parse(data);
  }

  initializeReactGA = () => {
    ReactGA.initialize('UA-135453231-2');
    ReactGA.pageview('/login');
  }

  fetchDataByStoreNumber = (e, history) => {
    const { storeNumber, loading } = this.state;

    if (!storeNumber) {
      this.setState({ isStoreNumberValid: false });
    }

    if (storeNumber && !loading) {
      this.setState({loading: true});

      fetch(`${API_URL}?action=get_store_data&store_number=${storeNumber}`)
        .then(response => response.json())
        .then(json => {
          const data = {
            ...json,
            storeNumber,
            email: "",
            loading: false,
            isStoreNumberValid: true,
            isTransitionFinished: false
          };

          window.sessionStorage.setItem("pickTicketData", JSON.stringify(data));
          this.setState(data);
          history.push("/introduction");
        })
        .catch(err => {
          this.setState({isStoreNumberValid: false, loading: false});
        })
    }
  };

  sendPdfWithStoreMetrics = () => {
    const { storeNumber, email } = this.state;
    fetch(
      `${API_URL}?action=send_pdf_to_email&store_number=${storeNumber}&email=${email}`
    );
  };

  resetData = () => {
    window.sessionStorage.removeItem("pickTicketData");
    this.setState({ ...initialState });
  };

  onFieldChange = e => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value, isStoreNumberValid: true });
  };

  render() {
    const {
      storeNumber,
      SKU_Count,
      Avg_Weekly_Sales,
      "Annual Sales": annualSales,
      Transaction_Count,
      BOPIS_Cancel_Retail,
      Extend_Cancel_Retail,
      email,
      isStoreNumberValid,
      loading
    } = this.state;

    this.initializeReactGA()

    return (
      <BrowserRouter forceRefresh={!supportsHistory}>
        <div>
          <main>
            <Route
              render={({ location }) => {
                const { pathname } = location;
                return (
                  <TransitionGroup>
                    <CSSTransition
                      key={pathname}
                      classNames="page"
                      timeout={{
                        enter: 1000,
                        exit: 1000
                      }}
                    >
                      <Route
                        location={location}
                        render={props => (
                          <Switch>
                            <Route
                              exact
                              path="/"
                              render={() => (
                                <Login
                                  storeNumber={storeNumber}
                                  onStoreNumberChange={this.onFieldChange}
                                  onStartClick={this.fetchDataByStoreNumber}
                                  resetData={this.resetData}
                                  isStoreNumberValid={isStoreNumberValid}
                                  loading={loading}
                                  {...props}
                                />
                              )}
                            />
                            <Route
                              path="/login"
                              render={() => (
                                <Login
                                  storeNumber={storeNumber}
                                  onStoreNumberChange={this.onFieldChange}
                                  onStartClick={this.fetchDataByStoreNumber}
                                  resetData={this.resetData}
                                  isStoreNumberValid={isStoreNumberValid}
                                  loading={loading}
                                  {...props}
                                />
                              )}
                            />
                            <Route
                              path="/introduction"
                              render={() => (
                                <Introduction
                                  resetData={this.resetData}
                                  {...props}
                                />
                              )}
                            />
                            <Route
                              path="/arrival"
                              render={() => (
                                <Arrival
                                  resetData={this.resetData}
                                  {...props}
                                />
                              )}
                            />
                            <Route
                              path="/problem/1"
                              render={() => (
                                <Problem
                                  storeNumber={storeNumber}
                                  SKU_Count={SKU_Count}
                                  Avg_Weekly_Sales={Avg_Weekly_Sales}
                                  annualSales={annualSales}
                                  resetData={this.resetData}
                                  {...props}
                                />
                              )}
                            />
                            <Route
                              path="/problem/2"
                              render={() => (
                                <Problem2
                                  storeNumber={storeNumber}
                                  Transaction_Count={Transaction_Count}
                                  resetData={this.resetData}
                                  {...props}
                                />
                              )}
                            />
                            <Route
                              path="/problem/3"
                              render={() => (
                                <Problem3
                                  storeNumber={storeNumber}
                                  BOPIS_Cancel_Retail={BOPIS_Cancel_Retail}
                                  Extend_Cancel_Retail={Extend_Cancel_Retail}
                                  resetData={this.resetData}
                                />
                              )}
                            />
                            <Route
                              path="/solution/1"
                              render={() => (
                                <Solution
                                  resetData={this.resetData}
                                  {...props}
                                />
                              )}
                            />
                            <Route
                              path="/solution/2"
                              render={() => (
                                <Solution2
                                  resetData={this.resetData}
                                  {...props}
                                />
                              )}
                            />
                            <Route
                              path="/solution/3"
                              render={() => (
                                <Solution3
                                  resetData={this.resetData}
                                  {...props}
                                />
                              )}
                            />
                            <Route
                              path="/conclusion"
                              render={() => (
                                <Conclusion
                                  resetData={this.resetData}
                                  email={email}
                                  storeNumber={storeNumber}
                                  onEmailChange={this.onFieldChange}
                                  sendPdfWithStoreMetrics={
                                    this.sendPdfWithStoreMetrics
                                  }
                                  {...props}
                                />
                              )}
                            />
                            <Route component={Error404} />
                          </Switch>
                        )}
                      />
                    </CSSTransition>
                  </TransitionGroup>
                );
              }}
            />
          </main>
        </div>
      </BrowserRouter>
    );
  }
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
